import React, { useMemo } from "react";
import get from "lodash/get";
import cx from "classnames";

import { Avatar } from "../../../../../components/Avatar/Avatar";

import { titles } from "./constants";
import { concatNameFromSignatory } from "../../../../../utils/concatName";
import { StyledCheckList } from "./styled";

const statusesToHighlight = ["Decline"];

export const CheckList = ({
  signatoryInfo,
  companyChecks,
  companyInfo,
  companyAdditionalInfo,
  isReviewSubmit,
  ...props
}) => {
  const headingClassName = cx("checkListData", "heading");

  // Sort signatoryInfo to display signatories with isSignatory true first
  const sortedSignatoryInfo = useMemo(() => {
    return [...signatoryInfo].sort(
      (signatory1, signatory2) =>
        signatory2.kycDetails.isSignatory - signatory1.kycDetails.isSignatory
    );
  }, [signatoryInfo]);

  return (
    <StyledCheckList isReviewSumbit={isReviewSubmit}>
      <h4 className="title">{titles.COMPANY_TITLE}</h4>
      {companyInfo.length ? (
        <div className="wrapper">
          <div className="applicationRow">
            <div className={headingClassName}>{titles.CHECK_NAME_TITLE}</div>
            <div className={headingClassName}>{titles.STATUS_TITLE}</div>
            <div className={headingClassName}>{titles.RESULT_REASON_TITLE}</div>
          </div>
          {companyChecks.map((application, index) => {
            const changeBackground = statusesToHighlight.includes(application.screeningReason)
              ? "declined"
              : "";
            return (
              <div
                className={cx("applicationRow", changeBackground)}
                key={`${application.screeningType}-${index}`}
              >
                <div className="checkListData">{application.screeningType}</div>
                <div className="checkListData">{application.screeningStatus}</div>
                <div className="checkListData">{application.screeningReason}</div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="errorMsg">Company check list is not available.</div>
      )}
      <h4 className="title">{titles.COMPANY_ADDITIONAL_INFO}</h4>
      <div className="wrapper">
        <div className="applicationRow">
          <div className={headingClassName}>{titles.CHECK_NAME_TITLE}</div>
          <div className={headingClassName}>{titles.STATUS_TITLE}</div>
          <div className={headingClassName}>{titles.RESULT_REASON_TITLE}</div>
        </div>
        {companyAdditionalInfo.length ? (
          companyAdditionalInfo.map((application, index) => {
            const changeBackground = statusesToHighlight.includes(application.screeningReason)
              ? "declined"
              : "";
            return (
              <div
                className={cx("applicationRow", changeBackground)}
                key={`${application.screeningType}-${index}`}
              >
                <div className="checkListData">{application.screeningType}</div>
                <div className="checkListData">{application.screeningStatus}</div>
                <div className="checkListData">{application.screeningReason}</div>
              </div>
            );
          })
        ) : (
          <div className="errorMsgInsideTable">
            Check list is not available for company additional info.
          </div>
        )}
      </div>
      {isReviewSubmit ? <h4 className="title">{titles.STAKEHOLDER_TITLE}</h4> : null}
      {signatoryInfo.length ? (
        sortedSignatoryInfo.map((signatory, index) => {
          const signatoryFullName =
            signatory?.editedFullName || signatory.fullName || concatNameFromSignatory(signatory);
          return (
            <div key={signatory.signatoryId}>
              {!isReviewSubmit && signatory.firstName ? (
                <div className={cx("contentWrapper", "checkListSignatoryInfoSection")}>
                  <Avatar fullName={signatoryFullName} index={index} />
                  <div className="userInfo">
                    <div className="nameField">{signatoryFullName}</div>
                  </div>
                </div>
              ) : (
                <></>
              )}

              <div className="wrapper" data-testid="stakeholder-checklist">
                <div className="applicationRow">
                  <div className={headingClassName}>{titles.CHECK_NAME_TITLE}</div>
                  <div className={headingClassName}>{titles.STATUS_TITLE}</div>
                  <div className={headingClassName}>{titles.RESULT_REASON_TITLE}</div>
                </div>
                {get(signatory, "screeningInfo.screeningResults", []).length ? (
                  signatory.screeningInfo.screeningResults.map((application, index) => {
                    const changeBackground = statusesToHighlight.includes(
                      application.screeningReason
                    )
                      ? "declined"
                      : "";
                    return (
                      <div
                        className={cx("applicationRow", changeBackground)}
                        key={`${application.screeningType}-${index}`}
                      >
                        <div className="checkListData">{application.screeningType}</div>
                        <div className="checkListData">{application.screeningStatus}</div>
                        <div className="checkListData">{application.screeningReason}</div>
                      </div>
                    );
                  })
                ) : (
                  <div className="errorMsgInsideTable">
                    Check list is not available for this stakeholder.
                  </div>
                )}
              </div>
            </div>
          );
        })
      ) : (
        <div className="errorMsg">Stakeholder check list is not available.</div>
      )}
    </StyledCheckList>
  );
};
